import React, { useRef } from 'react';
import useAnalyticsActionOnScroll from '../../../hooks/useAnalyticsActionOnScroll';

const AnalyticsVisibleEvent = ({ children, event, title = '', isEditorial = false, className = '', productLine = '', sendEvent = true, }) => {
  const elementRef = useRef<HTMLDivElement | null>(null);
  useAnalyticsActionOnScroll(elementRef, event, title, isEditorial, productLine, sendEvent);

  return (
    <div ref={elementRef} className={className}>
      {children}
    </div>
  );
};

export default AnalyticsVisibleEvent;
